module.exports = __webpack_public_path__ + "img/SupplierPerformance.5093d3c6.svg";